import { useEffect } from 'react';
import { useQuery } from 'react-query';

import minutesToMilliseconds from 'date-fns/minutesToMilliseconds';

import { fetchMaintenance } from '@api/common';
import { useWebView } from '@utils/webview';

const tenMinutes = minutesToMilliseconds(10);

export const Maintenance = () => {
  const { web } = useWebView();

  const maintenanceQuery = useQuery('maintenance', fetchMaintenance, {
    staleTime: tenMinutes,
    cacheTime: tenMinutes,
    refetchInterval: tenMinutes,
    suspense: false,
  });
  const { data } = maintenanceQuery;

  useEffect(() => {
    if (data?.isMaintenance) {
      web.startMaintenance();
    }
  }, [data?.isMaintenance]);

  return null;
};
